import axios from "axios";
import { API_BASE_URL } from "../../config";

const BASE = API_BASE_URL.endsWith("/api") ? API_BASE_URL : `${API_BASE_URL}/api`;

export const getPnLComparison = async (numYears = 5) => {
  try {
    const response = await axios.get(`${BASE}/reports/pnl-comparison`, {
      params: { num_years: numYears },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching PnL comparison:", error);
    throw error;
  }
};
